<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <!-- <img class="pointer" @click="returnBack()" src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/back.svg" alt="" /> -->
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="returnBack()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>


      <div class="secondstep" v-if="localStepNum == 1 || localStepNum == 0">
        <div style="margin-bottom: 10px">
          <jd-tip>
            说明<br />
            <template v-if="venderType">
              <p v-if="jdCrm.isCrm">
                1、云短信CRM：订购到期时间{{
                  jdCrm.endTime
                }}（自营店铺需要搭配<span
                  @click="toCRM"
                  class="pointer"
                  style="color: #fe4d45"
                  >云短信CRM</span
                >使用）
              </p>
              <p v-else>
                1、自营店铺需要搭配云短信CRM使用，<span
                  style="color: #fe4d45; cursor: pointer"
                  @click="toCRM"
                  >前往订购>></span
                >
              </p>
              <p>2、订单完成后发放奖励。</p>
            </template>
            <template v-else>
              <p>1、订单完成后发放奖励。</p>
            </template>
          </jd-tip>
        </div>

        <el-form
          :model="ruleForm"
          :rules="rules"
          class="backgroundForm new-input-box"
          ref="ruleForm"
          label-width="140px"
        >
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember" 
            :defaultActivityStartTime="ruleForm.startTime"
            :defaultActivityEndTime="ruleForm.endTime" 
            :plusObject.sync="ruleDto.plusObject"
            :isCheckOpenCardTime.sync="ruleDto.isCheckOpenCardTime"
            :openCardStartTime.sync="ruleDto.openCardStartTime"
            :openCardEndTime.sync="ruleDto.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- <jd-title label="基本信息" type="bold"></jd-title>
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              :disabled="activityData.isStart"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.startTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.endTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                @focus="orderFocus(1)"
                :picker-options="pickerOptionsValueEnd"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart"
                @click="clearTime(2)"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
              <span style="color: #fe4d45">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
            <div class="act-tip" v-if="isShowEndTip">
              *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
            </div>
          </el-form-item>
          <el-form-item label="活动对象:" prop="partner">
            <el-radio
              v-model="actMember"
              label="1"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="actMember"
              label="2"
              :disabled="activityData.isStart"
              >会员身份</el-radio
            >
            <el-radio
              v-model="actMember"
              label="3"
              :disabled="activityData.isStart || softType == 1"
              >指定人群
              <el-button
                style="margin-left: 10px"
                v-if="actMember == '3'"
                :disabled="activityData.isStart"
                @click="openCrowd"
                >已选人群({{ peopleSelected.length }})</el-button
              >
            </el-radio>

            <div v-if="actMember == '2'" style="display: flex">
              <span>会员等级：</span>
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="activityData.isStart"
                v-if="actMember == '2'"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >非会员</el-checkbox
                >
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div v-if="actMember == '2'" style="display: flex">
              <span>入会时间：</span>
              <el-checkbox
                v-model="ruleDto.isCheckOpenCardTime"
                :disabled="activityData.isStart"
                >指定时间段</el-checkbox
              >
              <div class="my_select_time" style="margin-left: 8px">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  :picker-options="openCardEndTimeOptionsValue"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <i
                  v-if="!activityData.isStart"
                  class="el-icon-circle-close date_icon1"
                  @click="clearNewTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color: #f56c6c"
              >注意：该条件对【非会员】身份不生效</span
            >

            <span v-if="localStepNum == 3"
              >注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span
            >
          </el-form-item>
          <el-form-item label="Plus会员身份:" required>
            <el-radio
              v-model="ruleDto.plusObject"
              :label="0"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="1"
              :disabled="activityData.isStart"
              >Plus会员</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="2"
              :disabled="activityData.isStart"
              >非plus会员</el-radio
            >
            <div style="color: #f56c6c">
              注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
            </div>
          </el-form-item>

          <el-form-item label="活动条件:">
            <el-checkbox
              label="关注店铺后方可参与活动"
              v-model="ruleForm.condFollow"
              :disabled="activityData.isStart"
            ></el-checkbox>
          </el-form-item> -->

          <jd-title label="下单规则" type="bold"></jd-title>
          <el-form-item label="抽奖条件:" prop="exposure" required>
            <!-- <span>下单付款后即可参与活动（预售商品需要支付尾款才可参与活动）</span> -->
            <div class="rule_box">
              <div class="rule_box_top">所下订单需满足如下条件</div>
              <div class="rule_box_middle">
                <el-form-item label="下单店铺:" required>
                  <div class="flex-shop">
                    <el-checkbox-group v-model="orderLotteryActivityPartakeRule.venderIds" @change="checkShopChange">
                      <el-checkbox :label="item.venderId" v-for="item in shopList" :key="item.venderId" :disabled="(item.venderId==venderId)||activityData.isStart">{{item.shopTitle}}</el-checkbox>
                      <el-tooltip effect="light" placement="top">
                        <template #content>
                          <div>
                            1.当前店铺默认勾选，且不可取消勾选；
                          </div>
                          <div>
                            2.仅展示当前账号有权限且为同一会员体系下的店铺；
                          </div>
                          <div>
                            3.多店情况下，①如统计规则为【单笔订单满】则表示用户在任意店铺的一笔订单满足条件即可，比如用户在A店有一笔订单满足条件，B店有两笔订单满足条件，则会根据下单时间选取符合条件中最早的一笔订单；②如统计规则为【累计订单满】则表示用户在任意店铺下单均会被累计，比如用户在A店、B店都有下单，则均会统计在内；
                          </div>
                        </template>
                        <el-button type="text" style="width: 35px;">
                          <i class="el-icon-question grey-color"></i>
                        </el-button>
                      </el-tooltip>
                    </el-checkbox-group>
                  </div>
                </el-form-item>
                <el-form-item label="下单时间:" required>
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="
                        orderLotteryActivityPartakeRule.lotteryCondition
                          .orderStartTime
                      "
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 145px; font-size: 12px"
                      class="time1"
                      @change="orderStartTimeChange"
                      @focus="orderFocus(2)"
                      :clearable="false"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="
                        orderLotteryActivityPartakeRule.lotteryCondition
                          .orderEndTime
                      "
                      default-time="23:59:59"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 145px; font-size: 12px"
                      class="time2"
                      @change="orderStartTimeChange"
                      @focus="orderFocus(2)"
                      :clearable="false"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      v-if="!activityData.isStart"
                      @click="clearTime(1)"
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="订单验证时间不得超过100天"
                    placement="bottom"
                  >
                    <el-button type="text" style="width: 35px">
                      <i class="el-icon-question" style="color: #ccc"></i>
                    </el-button>
                  </el-tooltip>
                  <div class="act-tip" v-if="isShowTip">
                    *提示：修改下单时间活动条件不会改变已参与用户的数据状态，修改仅适用于新用户参与活动的判定
                  </div>
                </el-form-item>
                <el-form-item label="金额统计类型:" required>
                  <el-radio-group v-model="orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType"
                    :disabled="activityData.isStart"
                  >
                    <el-radio :label="1">
                      <span>订单金额（后台价）</span>
                      <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                    <el-radio :label="0" v-if="!isVenderType">
                      <span>用户应付金额</span>
                      <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                    <el-radio :label="2" v-if="!isVenderType">
                      <span>用户实付金额</span>
                      <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                  </el-radio-group>
                  <div style="color: red">
                    注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                  </div>
                </el-form-item>
                <!-- 1.14迭代 -->
                <el-form-item label="订单金额:" required>
                  大于等于
                  <el-input
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .orderPriceLower
                    "
                    @input="
                      orderLotteryActivityPartakeRule.lotteryCondition.orderPriceLower =
                        setNumber($event, 1, true)
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input
                  >&nbsp; 元 &nbsp;
                  <!-- &nbsp; 元- &nbsp;
                  <el-input
                    v-model="orderLotteryActivityPartakeRule.lotteryCondition.orderPriceUpper"
                    @input="orderLotteryActivityPartakeRule.lotteryCondition.orderPriceUpper = getNumberData(1, $event, 1, 0)"
                    style="width:140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input
                  >&nbsp; 元<br> -->
                  <!-- <span style="color:red;margin-left:0px">注意：由于接口原因，pop支持统计实付金额，自营仅支持统计订单金额。</span> -->
                </el-form-item>
                <el-form-item label="商品件数:">
                  大于等于
                  <el-input
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .orderNumLower
                    "
                    @input="
                      orderLotteryActivityPartakeRule.lotteryCondition.orderNumLower =
                        setNumber($event, 1, true)
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input
                  >&nbsp; 件 &nbsp;
                  <!-- &nbsp; 件- &nbsp;
                  <el-input
                    v-model="orderLotteryActivityPartakeRule.lotteryCondition.orderNumUpper"
                    @input="orderLotteryActivityPartakeRule.lotteryCondition.orderNumUpper = getNumberData(1, $event, 1, 1)"
                    style="width:140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input
                  >&nbsp; 件 -->
                </el-form-item>
              </div>
              <div class="rule_box_bottom">
                <el-form-item label="指定购买商品:" required>
                  <el-radio
                    @change="filterTypeChange"
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .specifyGoods
                    "
                    :label="0"
                    :disabled="activityData.isStart"
                    >全部商品</el-radio
                  >
                  <el-radio
                    @change="filterTypeChange"
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .specifyGoods
                    "
                    :label="1"
                    :disabled="activityData.isStart"
                    >指定商品</el-radio
                  >
                  <el-radio
                    @change="filterTypeChange"
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .specifyGoods
                    "
                    :label="2"
                    :disabled="activityData.isStart"
                    >排除商品</el-radio
                  >
                  <jd-button
                    @click="exposureProducts(venderId)"
                    :disabled="activityData.isStart"
                    v-if="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .specifyGoods >= 1&&orderLotteryActivityPartakeRule.venderIds.length==1&&orderLotteryActivityPartakeRule.venderIds.includes(venderId)
                    "
                  >
                  已选择
                  {{ orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.length ? orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList[0].skuIds.length : 0 }}个
                  </jd-button>
                  <div v-else-if="orderLotteryActivityPartakeRule.venderIds.length>1&&orderLotteryActivityPartakeRule.lotteryCondition.specifyGoods >= 1">
                    <div v-for="item in orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList" :key="item.venderId">
                      <div class="flexc-cen-x mb8">
                        <div class="shoptitle-label">{{getTitle(item.venderId)}}</div>
                        <jd-button @click="exposureProducts(item.venderId)" v-loading="skuIdListLoading"
                          :disabled="activityData.isStart">
                          已选择
                          {{item.skuIds.length }}个
                        </jd-button>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="指定商品规则:" v-if="orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType==1&&orderLotteryActivityPartakeRule.lotteryCondition.specifyGoods == 1">
                  <el-select style="width: 280px;" v-model="orderLotteryActivityPartakeRule.lotteryCondition.filterSkuType" :disabled="activityData.isStart" placeholder="">
                    <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                    <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                  </el-select>
                  <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                </el-form-item>
                <el-form-item label="订单类型:" required>
                  <el-checkbox-group
                    :disabled="activityData.isStart"
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .orderTypeList
                    "
                  >
                    <el-checkbox :label="0">预售订单</el-checkbox>
                    <el-checkbox :label="1">普通订单</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                    <el-radio-group
                      :disabled="activityData.isStart"
                      v-model="orderLotteryActivityPartakeRule.lotteryCondition.mergeOrder"
                    >
                      <el-radio :label="false">否</el-radio>
                      <el-radio :label="true">是</el-radio>
                    </el-radio-group>
                    <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                  </el-form-item>
                <el-form-item label="订单状态:">
                  <el-select
                    :disabled="activityData.isStart"
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .orderState
                    "
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in orderStatusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-tooltip
                    effect="light"
                    popper-class="tip-order"
                    placement="bottom"
                  >
                    <div slot="content">
                      <div>
                        付尾款或付款：下单付款后即可参与活动（预售商品需要支付尾款才可参与活动）
                      </div>
                      <div>收货：订单完成后参与活动</div>
                    </div>
                    <el-button type="text" style="width: 35px">
                      <i class="el-icon-question" style="color: #ccc"></i>
                    </el-button>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="C端选择订单号:">
                  <div class="support">
                    <el-checkbox
                      v-model="ruleForm.isSupportOrderList"
                      :disabled="activityData.isStart"
                      :false-label="0"
                      :true-label="1"
                    ></el-checkbox>
                    <span class="support-text"
                      >用户参与活动时支持选择订单号，无需手动输入</span
                    >
                    <el-popover placement="top-start" trigger="hover">
                      <i
                        slot="reference"
                        class="el-icon-question support-icon"
                      ></i>
                      <div>
                        <img
                          src="https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/orderList_preview.png"
                          alt=""
                        />
                      </div>
                    </el-popover>
                  </div>
                </el-form-item>
              </div>
            </div>
            <!-- <div style="margin:5px 0 0 10px;color:#e0001b;">
              注：订单完成后发放奖励。整个活动期内每人只可参与1次,抽奖次数可自定义
            </div> -->
          </el-form-item>

          <!-- 1.14迭代需求 -->
          <el-form-item label="订单抽奖规则:" required>
            <div class="limit">
              <el-radio-group
                v-model="lsRadio"
                :disabled="activityData.isStart"
              >
                <div style="display: flex; flex-direction: column">
                  <el-radio :label="0">
                    活动期间仅可解锁1个订单，获得
                    <el-input
                      v-model.number="
                        orderLotteryActivityPartakeRule.winningCondition
                          .drawPerPersonNum
                      "
                      placeholder="请输入..."
                      @input="
                        orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum =
                          getNumberData(1, $event, 1, 1)
                      "
                      style="width: 70px"
                      :disabled="activityData.isStart"
                    ></el-input>
                    次抽奖机会
                  </el-radio>
                  <el-radio style="margin-top: 10px" :label="1"
                    ><span style="padding-left: 5px"
                      >活动期间解锁1个订单可获得1次抽奖机会，可解锁多个订单</span
                    ></el-radio
                  >
                </div>
              </el-radio-group>
              <!-- <p>
                每人<span class="c"></span>可抽奖次数
                <el-input
                  v-model.number="orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum"
                  placeholder="请输入..."
                  @input="orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum = getNumberData(1, $event, 1, 1)"
                  style="width: 70px;"
                  :disabled="activityData.isStart"
                ></el-input>
                次
                <el-tooltip
                  class="item"
                  effect="light"
                  content="解锁订单成功获取的抽奖次数，活动期间，多个订单符合，只能使用其中1个订单解锁1次。"
                  placement="bottom"
                >
                  <i class="el-icon-question" style="margin-left:10px;cursor:pointer;color:#ccc;"></i>
                </el-tooltip>
              </p> -->
            </div>
          </el-form-item>
          <!-- 1.14迭代需求 -->
          <el-form-item label="中奖限制:">
            <p>
              活动期间每人<span class="c"></span>中奖不超过
              <el-input
                v-model.number="
                  orderLotteryActivityPartakeRule.winningCondition
                    .winningNoMoreThanNum
                "
                @input="
                  orderLotteryActivityPartakeRule.winningCondition.winningNoMoreThanNum =
                    getNumberData(1, $event, 1, 1)
                "
                placeholder="不限制"
                style="width: 70px"
                :disabled="activityData.isStart"
              ></el-input>
              次
              <!-- , <span class="c">累计</span>中奖不超过
              <el-input
                v-model.number="bigTurntable.totalMaxRewardNumber"
                placeholder="请输入..."
                style="width: 70px"
                @input.native="checkputn"
              ></el-input>
              次, -->
            </p>
            <p class="desc" style="margin-left: 0; color: #f56c6c">
              <!-- <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/new_icon_reminder1.png"
                  style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 9px 4px 0 3px;
                "
                /> -->
              注:此处是对中奖次数做限制，不填写，表示不限制
            </p>
          </el-form-item>

          <jd-title label="奖品设置" type="bold"></jd-title>
          <el-form-item label="抽奖形式：" required>
            <el-radio-group v-model="orderLotteryActivityPartakeRule.luckyDrawForm" :disabled="activityData.isStart" @change="drawTypeChange">
              <el-radio :label="0">大转盘</el-radio>
              <el-radio :label="1">九宫格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item required>
            <div style="margin-top: 31px">订单完成后发放奖励</div>
            <span slot="label" class="set">奖品设置:</span>
            <div class="termAdd">
              <el-popover placement="right" width="270" trigger="hover">
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/wzsyt.png" alt="" />
                <span slot="reference">位置示意图</span>
              </el-popover>
              <p>
                累计中奖率: <span class="add">{{ winningRate }} %</span>
              </p>
            </div>
            <jd-table
              :tableData="prizeSettingList"
              style="width: 100%;"
            >
              <el-table-column label="位置">
                <template slot-scope="scope">
                  <span v-if="scope.row.index == 0">一</span>
                  <span v-if="scope.row.index == 1">二</span>
                  <span v-if="scope.row.index == 2">三</span>
                  <span v-if="scope.row.index == 3">四</span>
                  <span v-if="scope.row.index == 4">五</span>
                  <span v-if="scope.row.index == 5">六</span>
                  <span v-if="scope.row.index == 6">七</span>
                  <span v-if="scope.row.index == 7">八</span>
                </template>
              </el-table-column>

              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" v-if="activityData.isStart">选奖品</span>
                  <span class="s" @click="centerVis(scope.row)" v-else
                    >选奖品</span
                  >
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  {{ getPrizeTypeName(scope.row.prizeType) }}
                  <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">京东E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">礼品卡</span>
                  <span v-if="scope.row.prizeType == 12">{{venderType? '令牌' : '专享价'}}</span> -->
                </template>
              </el-table-column>

              <el-table-column label="值" width="80" prop="price">
                <!-- <template slot-scope="scope">
                {{ scope.row.price }}
              </template> -->
              </el-table-column>

              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.title"
                    :disabled="scope.row.prizeType == 9"
                    maxlength="12"
                    show-word-limit
                    style="width: 240px"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品总数" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.totalAmount"
                    @input.native="
                      (e) =>
                        (scope.row.totalAmount = checkputn(
                          e,
                          scope.row,
                          'jindou'
                        ))
                    "
                    placeholder="请输入"
                    style="width: 80px"
                    @input="
                      (scope.row.totalAmount = getNumberData(1, $event, 1, 1)),
                        prizeNum(scope.row)
                    "
                    @blur="beAdd(scope.row)"
                    :disabled="
                      (activityData.isStart && !scope.row.minNum) ||
                      activityData.isStart
                    "
                  ></el-input>
                  份
                </template>
              </el-table-column>

              <el-table-column label="每日发放限额" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.dailyLimit"
                    placeholder="请输入"
                    style="width: 80px"
                    @input="scope.row.dailyLimit = checkLimit(scope.row, 1)"
                    @blur="beAdd(scope.row)"
                    :disabled="
                      !activityData.status
                        ? false
                        : !scope.row.totalAmount
                        ? true
                        : false
                    "
                  ></el-input>
                  份
                </template>
              </el-table-column>

              <el-table-column label="中奖率" width="130">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.percentage"
                    placeholder="请输入"
                    style="width: 90px"
                    @keyup.native="
                      scope.row.percentage = oninput2(
                        scope.row.percentage,
                        scope.$index
                      )
                    "
                    :disabled="
                      !activityData.status
                        ? false
                        : !scope.row.totalAmount
                        ? true
                        : false
                    "
                  ></el-input>
                  %
                </template>
              </el-table-column>
              <el-table-column label="最多中奖次数" width="130">
                <template #header>
                  <el-tooltip
                      effect="light"
                      content="当单个用户中奖次数达到设定上限后，后续抽奖不再分配该奖品，系统自动重配其他奖品。"
                      placement="right"
                    >
                      <div>
                        最多中奖次数<i style="color: #ccc;" class="el-icon-question"></i>
                      </div>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.singleMaxWin"
                    placeholder="请输入"
                    style="width: 80px"
                    @input="scope.row.singleMaxWin = getNumberData(1, $event, 1, 0, 9999)"
                    :disabled="
                      !activityData.status
                        ? false
                        : !scope.row.totalAmount
                        ? true
                        : activityData.isStart ? true : false
                    "
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="图片" width="170">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.logo"
                    :src="scope.row.logo"
                    style="width: 56px; height: 56px"
                  />
                </template>
              </el-table-column>

              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <span class="s" v-if="activityData.isStart">清除</span>
                  <span class="s" @click="cleanData(scope.row)" v-else
                    >清除</span
                  >
                  <jd-button
                    type="blueText"
                    style="margin-left: 5px"
                    v-if="
                      activityData.isStart &&
                      scope.row.title &&
                      scope.row.title != '谢谢参与'
                    "
                    @click="itemAddNum('prizeSettingList', scope.$index)"
                    >增加奖品数量</jd-button
                  >
                </template>
              </el-table-column>
            </jd-table>
            <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
            <div style="margin-top: 16px">
              <jd-tip>
                说明<br />
                <p>
                  1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
                </p>
                <p>
                  2、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
                </p>
                <p>
                  3、为避免客诉，奖品中奖概率不建议设置为0；若奖品中奖概率一定要设置为0，一切后果由商家承担；
                </p>
                <p>
                  4、进行中的活动修改中奖概率有一定客诉风险，不建议频繁修改。
                </p>
              </jd-tip>
            </div>
          </el-form-item>
          <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleForm.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleForm.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleForm.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleForm.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <el-form-item label="中奖名单:">
            <el-radio-group v-model="ruleForm.isShowWinList">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <activityPageSettings isShowShopName isShowMoreSet isShowShopNameByChannel :designSpecificationsUrl="orderLotteryActivityPartakeRule.luckyDrawForm == 1 ? 'https://cdn-image.yucrm.cn/3b985a6a20c040a1b947181e34cfd132.png' : designSpecificationsList[activityData.id]" :cusTemplateJSON.sync="cusTemplateJSON" :isNeedSetBG="true" v-model="customerPaperwork" :isNeedCustomerPaperworkData="false" :giftList="currentGiftList" :templateId="templateId" @selectTemplate="selectTemplate" :widthNumber="750" :heightNumber="orderLotteryActivityPartakeRule.luckyDrawForm == 1 ? 1890 : 1933" :templatekey="'secondImageUrl'"></activityPageSettings>
          <exposureList :defaultExposureSwitch.sync="ruleForm.exposureSwitch" :isLimit="isLimit" :isEdit="isEdit" :multiShopSkuType.sync="orderLotteryActivityPartakeRule.multiShopSkuType" :multiShopGoods="multiShopGoods" v-model="itemListForFilter" :backgroundOpacity="backgroundOpacity" :skuBelongVenderId="orderLotteryActivityPartakeRule.skuBelongVenderId"></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleForm"></sharFrom>
          <activityRules :valueRow="valueRow" :activityData="activityData" :isForceRemind.sync="isForceRemind" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition" v-model="ruleForm.ruleDescription" @generateRule="generateRule"></activityRules>
          <!-- <jd-title label="曝光商品" type="bold"></jd-title>
          <el-form-item label="曝光商品:" class="zindexBox" style="z-index: 1">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
            >
              是否添加曝光商品
            </el-checkbox>
            <el-button
              :class="[
                { add_btn1: ruleForm.exposureSwitch },
                { 'global-view-btn': backgroundOpacity },
              ]"
              style="width: 155px; margin: 0 15px; display: inline-block"
              @click="exposureProductsFiter"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListForFilter.length != ""
                  ? "添加曝光商品" +
                    "(" +
                    itemListForFilter.length +
                    "/20" +
                    ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="ruleForm.exposureSwitch == false"
            >
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListForFilter.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px;
              "
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item> -->
          <!-- <template>
            <jd-title label="分享设置" type="bold"></jd-title>
            <el-form-item label="小程序分享标题:" required label-width="125">
              <el-input
                type="text"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.shareTitle"
                :maxlength="28"
                :disabled="activityData.isStart"
                @input="$forceUpdate()"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享简介:" required label-width="125">
              <el-input
                type="text"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.shareIntroduce"
                :maxlength="28"
                :disabled="activityData.isStart"
                @input="$forceUpdate()"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享图片:" required label-width="130">
              <div class="miniAppPic" style="margin-left: 16px">
                <div class="top">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="beforeUpload1"
                    :on-success="handleUpload1"
                    :disabled="activityData.isStart"
                  >
                    <jd-button type="blueText">自定义上传</jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    style="margin-left: 20px"
                    v-if="activityData.isStart"
                    >重置</jd-button
                  >
                  <jd-button
                    type="blueText"
                    style="margin-left: 20px"
                    @click="picUrlReset1"
                    v-else
                    >重置</jd-button
                  >
                </div>
                <div class="bottom">
                  <el-image
                    class="elImg"
                    :src="ruleForm.sharePic"
                    fit="contain"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-plus"></i>
                    </div>
                  </el-image>
                  <div class="tips1">
                    <p>建议上传尺寸：200px * 200px</p>
                    <p>图片大小：1MB以内</p>
                    <p>格式：jpg、png</p>
                  </div>
                </div>
              </div>
            </el-form-item>
          </template> -->
          <!-- <jd-title label="活动规则" type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                maxlength="8000"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.ruleDescription"
              >
              </el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.ruleDescription.length
                    ? ruleForm.ruleDescription.length
                    : 0
                }}/8000）
              </div>
              <div style="margin-top: 16px">
                <jd-button type="blue" @click="generateRule"
                  >生成规则</jd-button
                >
              </div>
              <div class="rule-tip">
                <jd-tip color="gley">
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </jd-tip>
              </div>
            </div>
          </el-form-item> -->

          <!-- <div
            v-if="backgroundOpacity"
            class="backgroundOpacity"
            style="height: calc(100% - 45px)"
          ></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <jd-button
        v-if="(localStepNum != 0&&localStepNum != 1)||backgroundOpacity"
        style="margin-right: 8px"
        v-show="!itemId"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>
      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :actType="19"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
    >
    </selectProduct>

    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          >确 定</jd-button
        >
      </div>
    </el-dialog>

    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
      :venderId="curretnVenderId"
      isInteract
      isLimit
      :limitNum="5000"
    ></selectGoodsMonitor>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- 选择人群弹窗 -->
    <selectPeople
      v-if="selectPeopleShow"
      :dialogVisible="selectPeopleShow"
      :peopleList="peopleList"
      @confim="selectPeopleSure"
      @close="selectPeopleShow = false"
    ></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
  </div>
</template>

<script>
import selectPeople from "@/components/select-people-yunqi.vue";
import selectProduct from "./select_product_componentization.vue";
import draggable from "vuedraggable";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import QRCode from "qrcodejs2";
import { mapState } from "vuex";
import {
  bigTurntableDraw,
  bigTurntableDraw2,
  modifyBigTurn,
  getbigTurn,
  getOrderDraw,
  hdTaskTemplateGroup,
  sellerImage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";

import { uploadpic } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { publicOpen } from "@/api/jhk/public";
import { getShopList } from "@/api/public";
import addPrizeNum from "./components/add-prize-num.vue";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import activityRules from "./components/activityRules.vue"
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    informationForm,
    exposureList,
    sharFrom,
    activityPageSettings,
    activityRules
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    ids: {
      type: String,
      default: "",
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    getTitle() {
      return (venderId)=>{
        const item = this.shopList.find(v=> v.venderId == venderId)
        if(item) {
          return item.shopTitle
        } else {
          return ""
        }
      }
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    currentGiftList() {
      if(this.giftList && this.giftList.length > 0) {
        if(this.orderLotteryActivityPartakeRule.luckyDrawForm == 0) {
          return this.giftList.filter(v=> v.layout != 3)
        } else if (this.orderLotteryActivityPartakeRule.luckyDrawForm == 1) {
          return this.giftList.filter(v=> v.layout == 3)
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(5);
    },
    localStepNum(newVal) {
      if (newVal == 0) {
        // this.$nextTick(() => {
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "1" }), queryId);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "2" }), queryId2);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "3" }), queryId3);
        // });
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    // 只选pop店铺
    // isPop(newVal) {
    //   if(newVal) {
    //     this.orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType = 0
    //   } else {
    //     this.orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType = 1
    //   }
    // },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType = 1
      }
      //  else {
      //   this.orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType = 0
      // }
    },
  },
  data() {
    return {
      isLimit: true,
      // customerPaperwork:{},
      cusTemplateJSON:"",

      skuIdListLoading: false,
      isVenderType: false,
      isPop: false,
      // 当前选择店铺id
      curretnVenderId: "",
      // 多店铺指定商品
      multiShopGoods: [],
      // 新增店铺列表
      shopList: [],
      selectShops: [],
      customerPaperwork:{},
      cusTemplateJSON:"",
      isForceRemind:false,
      isKeyActivity: 0,
      placementPosition: [],

      actEndTime: "",
      orderStartTime: "",
      orderEndTime: "",
      isShowEndTip: false,
      isShowTip: false,
      includeArr: [], //指定商品
      excludeArr: [], //排除商品
      showSelectProduct: false,
      // 1.14迭代需求
      lsRadio: 0,
      // 1.14迭代 指定入会时间
      ruleDto: {
        isCheckOpenCardTime: false,
        openCardStartTime: "",
        openCardEndTime: "",
        plusObject: 0, //plus会员
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.ruleDto.openCardEndTime).valueOf() -
                24 * 60 * 60 * 1000
          );
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf()
          );
        },
      },

      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      templateId: "",
      tabActive: 0,
      navItem: "",
      giftList: [],
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      itemArr: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      valueRow: null,
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() < new Date(this.ruleForm.startTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },

      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        term: [{ required: true, message: "请填写抽奖条件", trigger: "blur" }],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
      },
      draggingId: [], //有拖拽时要传的ID顺序
      mainImagelist: [], //图片拖拽排序
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      selectGoodsStateFilter: false,
      ruleForm: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        radio: 0,
        exposureSwitch: false,
        activityName: "",
        startTime: null,
        endTime: null,
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片

        goShopSetting: 0, //进店设置
        goShopAppId: "", //小程序appId
        goShopUrl: "", //小程序页面路径
        isSupportOrderList: 0,
        isValidBlackList: 0,
        isShowWinList: 1, // 中奖名单是否显示：1-显示 0-不显示（默认显示）
      },
      sharePic: "", // 初始图
      bigTurntable: {
        point: null,
        oneDayMaxDrawNumber: null,
        totalMaxDrawNumber: null,
        oneDayMaxRewardNumber: null,
        totalMaxRewardNumber: null,
      },
      // 抽奖条件
      orderLotteryActivityPartakeRule: {
        luckyDrawForm: 0,
        cusTemplateJSON:'',
        isForceRemind:false,
        venderIds: [],//新增下单店铺
        lotteryCondition: {
          orderEndTime: null,
          orderNumLower: "",
          orderNumUpper: "",
          orderPriceLower: "",
          orderPriceUpper: "",
          orderStartTime: null,
          // skuIds: [],
          specifyGoods: 0,
          filterSkuType: 0,
          popOrderStartPaymentType: 1,
          orderTypeList: [0, 1],
          orderState: 0,
          // 多店铺指定商品
          sellerSkuList: [],
          mergeOrder: false,
        },
        winningCondition: {
          drawPerPersonNum: null,
          winningNoMoreThanNum: null,
        },
        multiShopSkuType: 0,
        skuBelongVenderId: "",
      },
      bigTurntableDrawS: [],
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          percentage: null,
        },
      ],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      disableTime: false,
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      jdCrm: {
        startTime: "",
        endTime: "",
        isCrm: false,
      },
      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=19`,
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: "",
      toAddIndex: 0,
      orderStatusList: [
        {
          label: "付尾款或付款",
          value: 0,
        },
        {
          label: "收货",
          value: 1,
        },
      ],
      isEdit: false,
    };
  },
  created() {
    this.orderLotteryActivityPartakeRule.venderIds = [this.venderId]
    this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList = [{
      venderId: this.venderId,
      skuIds: [],
      itemList: [],
    }]
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    if (this.venderType) {
      this.orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType = 1;
    }
    this.getLevel();
    this.publicOpen();
    this.initDataSequence();
  },

  methods: {
    viewMergeLogic(){
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    viewStatisticsLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/ribmlurbi01iznn8?singleDoc#")
    },
    drawTypeChange(val) {
      console.log('luckyDrawForm',val);
      this.cusTemplateJSON = "";
      if(this.currentGiftList.length > 0) {
        this.templateId = this.currentGiftList[0].id;
      }
    },
    selectTemplate(index,templateId,items){
      if (sessionStorage.getItem("venderType") == 0) {
        // this.localStepNum = 1;
      } else {
        if (this.jdCrm.isCrm) {
          // this.localStepNum = 1;
        } else {
          this.$message({
            type: "warning",
            message: "自营店铺需要搭配云短信CRM使用!请联系客服!",
          });
        }
      }
      if (templateId) {
        this.templateId = templateId;
      }
      this.templateJson.templateUItype = index + 1;
    },
    async initDataSequence() {
      try {
          // 等待getShopAllList接口完成
          await this.getShopAllList();
          // 后续接口按顺序执行
          this.getDetail();
          this.hdTaskTemplateGroup();
        } catch (error) {
      }
    },
    getShopAllList() {
      return getShopList().then(res=>{
        if(res.code == 1){
          const resData = res.data.filter(item=> item)
          if (resData && resData.length){
            this.shopList = resData;
          } else {
            this.shopList = [
              {
                shopTitle: this.$store.getters.loginUserInfo.shopTitle,
                venderId: this.$store.getters.loginUserInfo.venderId,
                venderType: this.venderType,
                defaultFlag: true,
              },
            ];
          }
          this.getShopStatus([this.venderId])
        } else {
          this.shopList = [{
            shopTitle: this.$store.getters.loginUserInfo.shopTitle,
            venderId: this.venderId,
            venderType: this.venderType,
            defaultFlag: true
          }]
        }
      }).catch(()=>{
        this.shopList = [{
          shopTitle: this.$store.getters.loginUserInfo.shopTitle,
          venderId: this.venderId,
          venderType: this.venderType,
          defaultFlag: true
        }]
      })
    },
    getShopStatus(shopList) {
      this.multiShopGoods = this.shopList.filter((item)=>{
        return shopList.includes(item.venderId)
      })
      this.isVenderType = this.multiShopGoods.some((item)=>item.venderType);
      this.isPop = this.multiShopGoods.every((item)=>!item.venderType);
    },
    checkShopChange(shopList) {
      this.getShopStatus(shopList);
      // 1. 保存当前已选择的skuIds映射
      const existingSkuMap = new Map();
      this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.forEach(item => {
        existingSkuMap.set(item.venderId+'', item.skuIds);
      });

      // 2. 清空现有列表但保留映射关系
      this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList = [];
      // 3. 重新添加选中店铺，恢复原有skuIds
      shopList.forEach(venderId => {
        // 查找店铺信息
        const shopInfo = this.shopList.find(shop => shop.venderId == venderId);
        if (shopInfo) {
          this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.push({
            venderId: venderId,
            // 恢复已选择的skuIds，新店铺则初始化为空数组
            skuIds: existingSkuMap.get(venderId+'') || [],
            itemList: []
          });
        }
      });
    },
    // 点击下单时间显示提示
    orderFocus(type) {
      if (this.activityData.isStart) {
        if (type == 1) {
          this.isShowEndTip = true;
        } else {
          this.isShowTip = true;
        }
      }
    },
    filterTypeChange(val) {
      this.selectGoodsArr = [];
      this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.forEach((item)=>{
        item.skuIds = [];
        item.itemList = []
      })
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = "";
      this.ruleForm.goShopUrl = "";
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    setNumber(rawValue, minValue = 1, allowDecimals) {
      console.log(rawValue);
      if (rawValue == "") {
        return "";
      }
      // 尝试将原始值转换为数字
      let value = Number(rawValue);
      // 如果转换失败或小于最小值，则返回最小值
      if (isNaN(value) || value <= minValue) {
        return minValue;
      }
      // 如果不允许小数，则取整
      if (allowDecimals) {
        value = Math.floor(value);
      }
      // 返回值
      return value;
    },

    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    },
    // 京东计划数量计算
    prizeNum(row) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListForFilter = [];
        this.mainImagelist = [];
        this.selectGoodsFilterArr = [];
      }
      this.$forceUpdate();
    },

    selectGoodsCloseFilter(data) {
      console.log(data, 11111);
      if (data) {
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
        this.mainImagelist = this.itemListForFilter;
      }
      this.selectGoodsStateFilter = false;
    },

    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsStateFilter = false;
        return;
      }
    },

    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
      }
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },

    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
    },

    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },

    // 活动进行中修改奖品数量
    beAdd(row) {
      console.log(row);
      if (this.activityData.isStart) {
        if (Number(row.totalAmount) < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function () {
        const valid = image.width == 200 && image.height == 200;
        file.isFlag = valid;
        _this.uploadSize = valid;
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.info("图片宽高不符合要求,请重新上传");
          sizetype = false;
          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      let sizetype = false;
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        console.log(this.uploadSize);
        if (this.uploadSize) {
          this.ruleForm.sharePic = res.data;
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      this.ruleForm.sharePic = this.sharePic;
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      if(!this.templateId){
        const giftItem = this.giftList.find((item) => item.layout != 3);
        console.log('giftItem',giftItem);
        this.selectTemplate(0,giftItem.id,giftItem)
      }
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },

    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url =
        this.activityData.id == 14
          ? "http://yq-hd-rc.isvjcloud.com/shop.html"
          : "http://index.yeionsms.com/yidongd/index.html";
      const arr = [1, 8, 16, 17, 18, 19, 27, 28];
      if (arr.includes(Number(this.activityData.id))) {
        url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
      }
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text:
            this.activityData.id == 13
              ? `${url}?image=${this.giftList[index].templateUrl}`
              : arr.includes(Number(this.activityData.id))
              ? `${url}${this.giftList[index].secondImageUrl}`
              : `${url}?image=${this.giftList[index].templateExampleUrl}`,
        });
      }
    },

    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // //下边写用户输入时需要的执行逻辑
        // if(this.ruleForm.inputprize!= filtered) {
        //     this.ruleForm.inputprize = filtered
        // }
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    checkLimit(row, min) {
      let newVal = (row.dailyLimit + "").replace(/[^\d]/g, "");
      if (newVal) {
        if (newVal < min) {
          return "";
        } else {
          if (Number(row.dailyLimit) > Number(row.totalAmount)) {
            this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
            return "";
          } else {
            return Number(row.dailyLimit);
          }
        }
      }
    },
    //上传图片
    handleChange(file, fileList) {
      console.log(file, fileList, 333333);
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.fileList = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    httpRequest() {},
    //生成规则
    generateRule() {
      let order = this.orderLotteryActivityPartakeRule;
      let orderText1 = "";
      let orderText2 = "";
      let orderText3 = "";
      let orderText4 = "";
      let orderText5 = "";
      let orderText6 = "";
      let text1 = "参与方式：下单满足条件后可获得抽奖机会，在活动期间进入活动手动抽取奖品；",
        text2 = "有效订单不包含售中退款/售后退款，如成功参与活动的用户对商品订单进行售后行为，导致实际支付金额不足活动门槛金额的，或者因客户原因导致的恶意退款，视为用户不符合中奖资格，商家有权取消该用户获取奖品的资格;",
        text3 = "实物奖品需填写收货地址后进行发货；若收货地址填写截止时间前未填写收货信息视为自动放弃中奖资格，奖品失效处理，且奖品不予补发;",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        shopText = "",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【注意事项】";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember)
      // 下单时间
      if (
        order.lotteryCondition.orderEndTime &&
        order.lotteryCondition.orderStartTime
      ) {
        orderText1 =
          "抽奖条件：下单时间：" +
          order.lotteryCondition.orderStartTime +
          "~" +
          order.lotteryCondition.orderEndTime +
          ";";
      }
      if(this.multiShopGoods.length>1) {
        shopText = "下单店铺：" + this.multiShopGoods.map((item)=>item.shopTitle).join("，") + "；"
      }

      if (order.lotteryCondition.popOrderStartPaymentType == 0) {
        orderText1 += "金额统计类型：实付金额；";
      } else {
        orderText1 += "金额统计类型：订单金额;";
      }
      // 商品件数
      if (
        order.lotteryCondition.orderNumLower &&
        order.lotteryCondition.orderNumUpper
      ) {
        orderText3 =
          "商品件数：" +
          order.lotteryCondition.orderNumLower +
          "件~" +
          order.lotteryCondition.orderNumUpper +
          "件;";
      }
      if (
        order.lotteryCondition.orderNumLower &&
        !order.lotteryCondition.orderNumUpper
      ) {
        orderText3 =
          "商品件数：大于等于" + order.lotteryCondition.orderNumLower + "件;";
      }
      if (
        !order.lotteryCondition.orderNumLower &&
        !order.lotteryCondition.orderNumUpper
      ) {
        orderText3 = "商品件数：不限;";
      }
      // 订单金额：
      if (
        order.lotteryCondition.orderPriceLower &&
        order.lotteryCondition.orderPriceUpper
      ) {
        orderText2 =
          "订单金额：" +
          order.lotteryCondition.orderPriceLower +
          "元~" +
          order.lotteryCondition.orderPriceUpper +
          "元;";
      }
      if (
        order.lotteryCondition.orderPriceLower &&
        !order.lotteryCondition.orderPriceUpper
      ) {
        orderText2 =
          "订单金额：大于等于" + order.lotteryCondition.orderPriceLower + "元;";
      }
      if (order.lotteryCondition.orderTypeList.length > 0) {
        if (order.lotteryCondition.orderTypeList.length == 2) {
          orderText4 = "订单类型：预售订单，普通订单；";
        } else {
          if (order.lotteryCondition.orderTypeList.includes(0)) {
            orderText4 = "订单类型：预售订单；";
          } else {
            orderText4 = "订单类型：普通订单；";
          }
        }
      }
      if (order.lotteryCondition.orderState == 0) {
        orderText5 = "订单状态：付尾款或付款";
      } else {
        orderText5 = "订单状态：收货";
      }
      if (order.lotteryCondition.specifyGoods == 0) {
        orderText6 = "指定购买商品：全部商品;";
      } else if (order.lotteryCondition.specifyGoods == 1) {
        orderText6 = "指定购买商品：指定商品;";
      } else {
        orderText6 = "指定购买商品：排除商品;";
      }

      text5 = 
       "抽奖条件：" +
        shopText +
        orderText1 +
        orderText2 +
        orderText3 +
        orderText6 +
        orderText4 +
        orderText5;

      // 1.14迭代
      if (this.lsRadio == 0 && order.winningCondition.drawPerPersonNum) {
        text6 =
          "订单抽奖规则：活动期间仅可解锁1个订单，获得" +
          order.winningCondition.drawPerPersonNum +
          "次抽奖机会";
      }
      if (this.lsRadio == 1) {
        text6 =
          "订单抽奖规则：活动期间解锁1个订单可获得1次抽奖机会，可解锁多个订单";
      }

      text7 = "中奖限制：";
      if (order.winningCondition.winningNoMoreThanNum) {
        text7 +=
          "活动期间每人中奖不超过" +
          order.winningCondition.winningNoMoreThanNum +
          "次";
      } else {
        text7 += "不限制";
      }

      let Arr1 = [
        firstText,
        [secondText, text1,text5,text6,text7,text2,text3],
        [thirdText,precautions]
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });

      this.ruleForm.ruleDescription = newText;
    },
    //清除
    cleanData(row) {
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleMaxWin = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.dailyLimit = null;
      row.shouldCollectExtraData = 0
      row.extraQuestion = null
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(5);
      }
    },
    //选择奖品弹窗
    centerVis(row) {
      this.itemArr = this.prizeSettingList;
      this.index = row.index;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.showSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      // this.$emit("returnBack");
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price = Number(data.discount);

      this.prizeSettingList[this.index].assetsId = Number(data.couponId || data.skuId);
      this.prizeSettingList[this.index].logo = data.logo;
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = data.discount + "店铺积分";
      } else {
        this.prizeSettingList[this.index].title = data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.prizeSettingList[this.index].addressFillEndTime = data.addressFillEndTime
          this.prizeSettingList[this.index].predictSendTime = data.predictSendTime
          this.prizeSettingList[this.index].isFollowActivityEndTime = data.isFollowActivityEndTime
          this.prizeSettingList[this.index].skuId = data.skuId;
          delete this.prizeSettingList[this.index].isGoodManage;
          this.prizeSettingList[this.index].shouldCollectExtraData = data.shouldCollectExtraData;
          this.prizeSettingList[this.index].extraQuestion = data.extraQuestion;
          this.prizeSettingList[this.index].addressFillLimit = data.addressFillLimit;
          this.prizeSettingList[this.index].commitAddressLimit = data.commitAddressLimit;
        } else {
          this.prizeSettingList[this.index].isGoodManage = data.isGoodManage;
        }
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.prizeSettingList[this.index],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      this.showSelectProduct = false;
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      console.log(this.prizeSettingList, "obj");
      let order = this.orderLotteryActivityPartakeRule;
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      let nowTime = new Date().getTime();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      // if (this.actMember == "2") {
      //   if (
      //     this.ruleDto.isCheckOpenCardTime &&
      //     (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
      //   ) {
      //     return this.$message.warning("请选择入会时间");
      //   }
      // }

      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          (!this.ruleForm.openCardBeforeDay)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }

      if (
        !(
          order.lotteryCondition.orderEndTime &&
          // order.lotteryCondition.orderNumLower.toString() &&
          order.lotteryCondition.orderPriceLower.toString() &&
          order.lotteryCondition.orderStartTime
        )
      ) {
        this.$message.warning("请输入抽奖条件");
        return;
      }
      // 指定商品
      if(this.orderLotteryActivityPartakeRule.lotteryCondition.specifyGoods!=0&&this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.length>0){
        let flag = false
        this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.some((item)=>{
          if(item.skuIds.length==0) {
            flag = true
          }
        })
        if(flag&&this.orderLotteryActivityPartakeRule.lotteryCondition.specifyGoods==1) {
          return this.$message.warning("请选择指定商品");
        } else if(flag&&this.orderLotteryActivityPartakeRule.lotteryCondition.specifyGoods==2) {
          return this.$message.warning("请选择排除品");
        }
      }
      // 订单类型校验
      if (
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderTypeList
          .length == 0
      ) {
        this.$message.warning("至少勾选一项订单类型");
        return;
      }
      // 请将奖品填写完整！
      let isFlay = false;

      this.prizeSettingList.forEach((item) => {
        if (item.prizeType != 9) {
          if (!item.totalAmount) {
            isFlay = true;
          }
        }
      });

      if (isFlay) {
        return this.$message.warning("请将奖品填写完整！");
      }

      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }

      //新增进店设置校验
      if (this.ruleForm.goShopSetting == 1 && !this.ruleForm.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.ruleForm.goShopSetting == 2) {
        if (!this.ruleForm.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.ruleForm.goShopUrl.startsWith("https://") ||
          !this.ruleForm.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListForFilter.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }

      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }

      // 1.14迭代需求 这里验证
      if (this.lsRadio == 0 && !order.winningCondition.drawPerPersonNum) {
        this.$message.warning("请完善订单抽奖规则");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }

      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    handleDialogCloseAnoth() {
      console.log("handleDialogCloseAnoth===>")
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.orderLotteryActivityPartakeRule = this.deepClone(this.orderLotteryActivityPartakeRule)
        

      // 1.14迭代需求 抽奖条件这里提交
      obj.orderLotteryActivityPartakeRule.winningCondition.drawNumType =
        this.lsRadio;
      if (this.lsRadio == 1) {
        obj.orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum = 1;
      }

      obj.orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType =
        this.orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType;
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0; //是否添加曝光商品 0 否 1 是
      if (obj.isExposureItem) {
        obj.itemList = this.itemListForFilter;
      }
      obj.priceType = this.ruleForm.radio; //  0：显示京东价 1：显示促销
      obj.integralParadisePrizeDTOS = this.deepClone(this.prizeSettingList);
      obj.integralParadisePrizeDTOS.forEach((item, index) => {
        item.percentage = Number(item.percentage);
        if (item.prizeType != 9) {
          if (item.prizeType == 2 || item.prizeType == 4) {
            item.singleAmount = item.price;
          } else {
            item.singleAmount = 1;
          }
          if (item.prizeType == 3) {
            item.assetsId = item.skuId || item.assetsId;
          }
        }
      });
      obj.templateJson = this.templateJson; //多个模板
      if (this.activityData.id == 2) {
        delete obj.templateJson;
      }
      obj.allowLevel = this.ruleForm.partner.join(","); //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      // 1.14迭代需求 这里提交 指定入会时间

      obj.orderLotteryActivityPartakeRule.isCheckOpenCardTime =
        this.actMember == 2 ? this.ruleDto.isCheckOpenCardTime : false;
      obj.orderLotteryActivityPartakeRule.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType;
      obj.orderLotteryActivityPartakeRule.openCardFollow = this.ruleForm.openCardFollow;
      if(this.ruleForm.firstOpenCardTimeType == 1) {
        obj.orderLotteryActivityPartakeRule.openCardBeforeDay = this.ruleForm.openCardBeforeDay;
      }
      if (this.ruleForm.firstOpenCardTimeType == 2) {
        obj.orderLotteryActivityPartakeRule.openCardStartTime =
          this.actMember == 2 ? this.ruleDto.openCardStartTime : "";
        obj.orderLotteryActivityPartakeRule.openCardEndTime =
          this.actMember == 2 ? this.ruleDto.openCardEndTime : "";
      }
      obj.orderLotteryActivityPartakeRule.plusObject = this.ruleDto.plusObject;

      obj.templateId = this.templateId;
      obj.orderLotteryActivityPartakeRule.shareTitle = this.ruleForm.shareTitle;
      obj.orderLotteryActivityPartakeRule.shareIntroduce =
        this.ruleForm.shareIntroduce;
      obj.orderLotteryActivityPartakeRule.sharePic = this.ruleForm.sharePic;
      if(obj.orderLotteryActivityPartakeRule.lotteryCondition.specifyGoods==0) {
        obj.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList = []
      } else {
        //删除多余参数
        obj.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.forEach((item)=>{
          delete item.itemList
        })
      }
      // if(obj.orderLotteryActivityPartakeRule.lotteryCondition.skuIds&&obj.orderLotteryActivityPartakeRule.lotteryCondition.skuIds.length>0) {
      //   obj.orderLotteryActivityPartakeRule.lotteryCondition.skuIds = []
      // }
      // 进店逛逛配置
      (obj.orderLotteryActivityPartakeRule.goShopSetting =
        this.ruleForm.goShopSetting),
        (obj.orderLotteryActivityPartakeRule.goShopAppId =
          this.ruleForm.goShopAppId),
        (obj.orderLotteryActivityPartakeRule.goShopUrl =
          this.ruleForm.goShopUrl),
        delete obj.goShopSetting;
      delete obj.goShopAppId;
      delete obj.goShopUrl;

      // 中奖名单显示配置
      obj.orderLotteryActivityPartakeRule.isShowWinList =
        this.ruleForm.isShowWinList;
      delete obj.isShowWinList;

      // 订单列表
      obj.orderLotteryActivityPartakeRule.lotteryCondition.isSupportOrderList =
        this.ruleForm.isSupportOrderList;
      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel = this.ruleForm.partner.join(",");
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }

      obj.orderLotteryActivityPartakeRule.cusTemplateJSON = this.cusTemplateJSON
      obj.orderLotteryActivityPartakeRule.customerPaperwork = JSON.stringify(this.customerPaperwork);
      obj.orderLotteryActivityPartakeRule.isForceRemind = this.isForceRemind
      obj.isKeyActivity = this.isKeyActivity
      obj.placementPosition = this.placementPosition.join(",")
      obj.orderLotteryActivityPartakeRule.placementPosition = this.placementPosition.join(",")
      if(obj.orderLotteryActivityPartakeRule.multiShopSkuType==0 && this.itemListForFilter.length) {
        obj.orderLotteryActivityPartakeRule.skuBelongVenderId = this.itemListForFilter[0].belongVenderId
      } else {
        obj.orderLotteryActivityPartakeRule.skuBelongVenderId = ""
      }
      if (this.activityData.isCopy && obj.id) delete obj.id;

      if (this.checked == true || this.isDraft) {
        if (this.activityData.isStart) {
          let params = {
            activityName: this.ruleForm.activityName,
            endTime:this.ruleForm.endTime,
            ruleDTO: obj.orderLotteryActivityPartakeRule,
            templateId:this.templateId,
            activityId: obj.id,
            // endTime: this.ruleForm.endTime,
            ruleDescription: obj.ruleDescription,
            prizes: obj.integralParadisePrizeDTOS
              .filter((item) => item.totalAmount)
              .map((item) => {
                return {
                  title:item.title,
                  prizeId: item.id,
                  totalAmount: !item.isWrite
                    ? item.totalAmount
                      ? item.totalAmount
                      : ""
                    : undefined,
                  dailyLimit: item.dailyLimit,
                  percentage: item.percentage,
                  singleMaxWin: item.singleMaxWin ? Number(item.singleMaxWin) : "",

                  isFollowActivityEndTime: item.isFollowActivityEndTime,
                  predictSendTime: item.predictSendTime,
                  addressFillEndTime: item.addressFillEndTime,
                  addressFillLimit: item.addressFillLimit,
                  // 提交地址限制：数组转逗号分隔字符串
                  commitAddressLimit: Array.isArray(item.commitAddressLimit) 
                    ? item.commitAddressLimit.join(',') 
                    : item.commitAddressLimit
                };
              }),
            isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
            itemList: this.itemListForFilter,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          if (
            this.orderStartTime !=
              obj.orderLotteryActivityPartakeRule.lotteryCondition
                .orderStartTime ||
            this.orderEndTime !=
              obj.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime
          ) {
            params.ruleDTO = obj.orderLotteryActivityPartakeRule;
          }
          if (this.actEndTime != this.ruleForm.endTime) {
            params.endTime = this.ruleForm.endTime;
          }
          updateCommon(params)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          if (this.isDraft) {
            obj.status = 5;
          } else {
            // 保存正式活动不需要status
            if (obj.status) {
              delete obj.status;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
          }
          if (this.activityData.isCopy) {
            delete obj.id;
          }
          bigTurntableDraw2(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.ids != "") {
        let id = this.ids;
        this.valueRow = {
          id: id,
        };
        getOrderDraw(id)
          .then((res) => {
            this.isEdit = true
            res.data.partner = res.data.allowLevel.split(",");
            if (res.data.allowLevel == "99") {
              this.peopleSelected = res.data.crowdIds.split(",");
              this.actMember = "3";
            } else if (res.data.allowLevel == "-1") {
              this.actMember = "1";
            } else {
              this.actMember = "2";
              if (res.data.allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              }
            }
            let data = res.data;
            // tapd 进店逛逛 (数据结构不一样，所以得提前赋值)
            data.goShopSetting =
              res.data.orderLotteryActivityPartakeRule.goShopSetting;
            data.goShopAppId =
              res.data.orderLotteryActivityPartakeRule.goShopAppId;
            data.goShopUrl = res.data.orderLotteryActivityPartakeRule.goShopUrl;
            // 中奖名单显示（数据结构不一样，提前赋值，Number兼容后端数字/字符串返回）
            data.isShowWinList = res.data.orderLotteryActivityPartakeRule.isShowWinList !== undefined && res.data.orderLotteryActivityPartakeRule.isShowWinList !== null
              ? Number(res.data.orderLotteryActivityPartakeRule.isShowWinList) : 1;
            this.ruleForm = data;
            this.ruleForm.activityName =
              res.data.activityName + (this.activityData.isCopy ? "复制" : "");
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            this.$set(
              this.ruleForm,
              "startTime",
              res.data.startTime ? res.data.startTime : null
            );
            this.$set(
              this.ruleForm,
              "endTime",
              res.data.endTime ? res.data.endTime : null
            );
            this.actEndTime = res.data.endTime;
            // this.ruleForm.partner = res.data.allowLevel.split(",");
            this.ruleForm.condFollow = Boolean(res.data.condFollow);
            this.customerPaperwork = res.data.orderLotteryActivityPartakeRule.customerPaperwork && JSON.parse(res.data.orderLotteryActivityPartakeRule.customerPaperwork) || {};
            this.bigTurntable = res.data.orderLotteryActivityPartakeRule;
            this.orderLotteryActivityPartakeRule =
              res.data.orderLotteryActivityPartakeRule;
            this.orderLotteryActivityPartakeRule.lotteryCondition.mergeOrder = res.data.orderLotteryActivityPartakeRule.lotteryCondition.mergeOrder || false;
            // 兼容活动
            if(!this.orderLotteryActivityPartakeRule.venderIds) {
              this.orderLotteryActivityPartakeRule.venderIds = [this.venderId]
            }
            if(!this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList||this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.length==0) {
              this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList = [{
                venderId: this.venderId,
                skuIds: [],
                itemList: [],
              }]
            }
            // 拷贝一份数据做判断
            this.orderStartTime =
              res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderStartTime;
            this.orderEndTime =
              res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime;
            // 1.14迭代 这里回显 包含指定入会时间、订单抽奖规则
            // 1.14迭代订单抽奖规则
            this.lsRadio =
              res.data.orderLotteryActivityPartakeRule.winningCondition.drawNumType;
            if (
              res.data.orderLotteryActivityPartakeRule.winningCondition
                .drawNumType == 1
            ) {
              this.orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum =
                "";
            } else {
              this.orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum =
                res.data.orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum;
            }
            this.ruleDto = {
              isCheckOpenCardTime:
                res.data.orderLotteryActivityPartakeRule.isCheckOpenCardTime,
              openCardStartTime:
                res.data.orderLotteryActivityPartakeRule.openCardStartTime,
              openCardEndTime:
                res.data.orderLotteryActivityPartakeRule.openCardEndTime,
              plusObject: res.data.orderLotteryActivityPartakeRule.plusObject, //plus会员
            };
            this.$set(this.ruleForm, 'openCardFollow', res.data.orderLotteryActivityPartakeRule.openCardFollow);
            this.$set(this.ruleForm, 'openCardBeforeDay', res.data.orderLotteryActivityPartakeRule.openCardBeforeDay);
            this.$set(this.ruleForm, 'firstOpenCardTimeType', res.data.orderLotteryActivityPartakeRule.firstOpenCardTimeType);
            if (res.data.orderLotteryActivityPartakeRule.isForceRemind) {
              this.isForceRemind = res.data.orderLotteryActivityPartakeRule.isForceRemind
            }
            if (res.data.isKeyActivity) {
              this.isKeyActivity = res.data.isKeyActivity
            }
            if (res.data.placementPosition) {
              this.placementPosition = res.data.placementPosition.split(",")
            }

            if(res.data.orderLotteryActivityPartakeRule.cusTemplateJSON){
              this.cusTemplateJSON = res.data.orderLotteryActivityPartakeRule.cusTemplateJSON 
            }


            this.templateId = res.data.templateId
            // 判断抽奖条件-空数据
            if (
              !this.orderLotteryActivityPartakeRule.lotteryCondition
                .orderNumLower
            ) {
              this.orderLotteryActivityPartakeRule.lotteryCondition.orderNumLower =
                "";
            }
            if (
              !this.orderLotteryActivityPartakeRule.lotteryCondition
                .orderNumUpper
            ) {
              this.orderLotteryActivityPartakeRule.lotteryCondition.orderNumUpper =
                "";
            }
            if (
              !this.orderLotteryActivityPartakeRule.lotteryCondition
                .orderPriceLower
            ) {
              this.orderLotteryActivityPartakeRule.lotteryCondition.orderPriceLower =
                "";
            }
            if (
              !this.orderLotteryActivityPartakeRule.lotteryCondition
                .orderPriceUpper
            ) {
              this.orderLotteryActivityPartakeRule.lotteryCondition.orderPriceUpper =
                "";
            }

            // 新增字段
            this.orderLotteryActivityPartakeRule.lotteryCondition.orderTypeList =
              res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderTypeList;
            this.orderLotteryActivityPartakeRule.lotteryCondition.orderState =
              res.data.orderLotteryActivityPartakeRule.lotteryCondition.orderState;
            
            this.orderLotteryActivityPartakeRule.luckyDrawForm = res.data.orderLotteryActivityPartakeRule.luckyDrawForm || 0;

            this.orderLotteryActivityPartakeRule = JSON.parse(
              JSON.stringify(this.orderLotteryActivityPartakeRule)
            );
            // 回显下单店铺
            if(res.data.orderLotteryActivityPartakeRule.venderIds&&res.data.orderLotteryActivityPartakeRule.venderIds.length>0) {
              this.orderLotteryActivityPartakeRule.venderIds = res.data.orderLotteryActivityPartakeRule.venderIds
            }
            this.getShopStatus(this.orderLotteryActivityPartakeRule.venderIds)
            if (!this.activityData.isCopy) {
              // 指定商品回显
              let skuIdsLength = res.data.orderLotteryActivityPartakeRule.lotteryCondition.skuIds?
                res.data.orderLotteryActivityPartakeRule.lotteryCondition.skuIds
                  .length:0;
              if (this.venderType) {
                this.orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType = 1;
              } else {
                this.orderLotteryActivityPartakeRule.lotteryCondition.popOrderStartPaymentType =
                  res.data.orderLotteryActivityPartakeRule.lotteryCondition
                    .popOrderStartPaymentType
                    ? res.data.orderLotteryActivityPartakeRule.lotteryCondition
                        .popOrderStartPaymentType
                    : 0;
              }
              if(data.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList&&data.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.length>0) {
                this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList = data.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.map((item)=>{
                  item.itemList = []
                  return item
                });
                let reqFn = []
                this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.forEach(item=>{
                  reqFn.push(getTaobaoItemListSku({
                    current: 1,
                    size: item.skuIds.length,
                    venderId: item.venderId,
                    skuIdStr: item.skuIds.join(",")
                  }))
                })
                Promise.all(reqFn).then((res)=>{
                  // 处理返回结果，将接口数据映射到对应item
                  this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.forEach((item, index) => {
                    item.itemList = res[index].data.records || [];
                  });
                })
              } else {
                this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList = [{
                  venderId: this.venderId,
                  skuIds: [],
                  itemList: [],
                }]
              }
              // 奖品设置
              this.prizeSettingList = res.data.bigTurntableDrawPrizeDTOS;
              this.prizeSettingList.forEach((item, index) => {
                item.minNum = item.totalAmount;
                item.index = index;
                item.isWrite = false;
                if (item.percentage) {
                  this.winningRate += Number(item.percentage);
                }
                // 提交地址限制回显：逗号分隔字符串转数字数组
                if (item.prizeType == 3) {
                  if (item.commitAddressLimit) {
                    item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                      ? item.commitAddressLimit.split(',').map(Number)
                      : item.commitAddressLimit;
                  } else {
                    item.commitAddressLimit = [0];
                  }
                }
              });
              this.templateJson = JSON.parse(res.data.templateJson);
              // 曝光商品
              this.ruleForm.exposureSwitch = res.data.isExposureItem
                ? true
                : false;
              this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
              if (this.ruleForm.exposureSwitch) {
                this.itemListForFilter = res.data.itemList;
                this.mainImagelist = res.data.itemList;
                this.selectGoodsFilterArr = res.data.itemList;
              }
            } else {
              if(data.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList&&data.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.length>0) {
                this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList = data.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.map((item)=>{
                  item.itemList = []
                  item.skuIds = []
                  return item
                });
              }
              this.ruleForm.ruleDescription = "";
            }
            if (this.activityData.isCopy||this.isDraftEdit) {
              // 跨店复制
              if(this.orderLotteryActivityPartakeRule.venderIds.length>0) {
                let index = this.orderLotteryActivityPartakeRule.venderIds.findIndex((item)=>{
                  return item == this.venderId
                })
                if(index==-1) {
                  this.orderLotteryActivityPartakeRule.venderIds.unshift(this.venderId)
                }
              }
            }
            // 订单列表
            this.$set(
              this.ruleForm,
              "isSupportOrderList",
              res.data.orderLotteryActivityPartakeRule.lotteryCondition
                .isSupportOrderList
            );
            // 分享设置回显
            this.ruleForm.shareTitle =
              res.data.orderLotteryActivityPartakeRule.shareTitle;
            this.ruleForm.shareIntroduce =
              res.data.orderLotteryActivityPartakeRule.shareIntroduce;
            this.ruleForm.sharePic =
              res.data.orderLotteryActivityPartakeRule.sharePic;

            this.activityTimeChange();
            this.winningRate = this.winningRate.toFixed(5);
          })
          .catch((res) => {});
      } else {
        if (this.venderType) {
          this.orderLotteryActivityPartakeRule.popOrderStartPaymentType = 1;
        }
        this.ruleForm.startTime = this.$getDate(30)[0];
        this.ruleForm.endTime = this.$getDate(30)[1];
        this.activityTimeChange();
      }
    },
    //清空时间
    clearTime(type) {
      if (type == 2) {
        this.ruleForm.startTime = "";
        this.ruleForm.endTime = "";
      } else if (type == 1) {
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderStartTime =
          "";
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime = "";
      }
    },
    // 活动时间改变
    activityTimeChange(val) {
      // 校验有无时间
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) return;
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      let CRMtime = new Date(this.jdCrm.endTime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.pointUserInfo.expiredIn
      ).valueOf();
      let hdInvalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiresIn
      ).valueOf();
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      if (this.ruleForm.endTime && this.ruleForm.startTime) {
        // daysStart = this.ruleForm.startTime.substring(0, 10);
        // daysEnd = this.ruleForm.endTime.substring(0, 10);
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        // this.timeDay = days;

        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(
          Math.abs(
            new Date(this.ruleForm.endTime) - new Date(this.ruleForm.startTime)
          ) /
            1000 /
            60 /
            60 /
            24
        );

        //计算小时
        date3 =
          new Date(this.ruleForm.endTime).getTime() -
          new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (start < nowTime) {
        if (this.ids) {
          this.disableTime = true;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        this.ruleForm.endTime = "";
        return;
      }
      if (end > invalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        this.ruleForm.endTime = "";
        return;
      }
      if (end > hdInvalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        this.ruleForm.endTime = "";
        return;
      }
    },
    // 下单时间
    orderStartTimeChange() {
      let start = new Date(
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderStartTime
      ).valueOf();
      let end = new Date(
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime
      ).valueOf();
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime =
          null;
        return;
      }
    },
    // 选择礼品
    choosegifts() {},
    // 保留小数点后两位
    oninput2(val, $index) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      this.prizeSettingList.forEach((item, index) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
        if ($index == index) {
          item.isWrite = true;
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      // return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
      return val ? val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d{1,5}).*$/, "$1$2.$3") : "";
    },
    oninput(val) {
      if (val && val <= 0) {
        val = "1";
      }
      return val;
    },

    //添加指定商品弹窗
    exposureProducts(venderId) {
      if(this.orderLotteryActivityPartakeRule.lotteryCondition.specifyGoods >= 1) {
        this.curretnVenderId = venderId;
      }
      this.selectGoodsState = true;
      if(this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.length>0) {
        this.selectGoodsArr = this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.filter(item=>item.venderId == venderId)[0].itemList;
      }
      this.$nextTick(() => {
        this.$refs.selectGo.handleRightCurrentChange(1);
      });
    },

    selectGoodsClose(data) {
      if (data) {
        let selectGoods = [];
        const skuIds = []
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoods.push(fomeVaule);
          skuIds.push(data[index].skuId)
        });
        this.selectGoodsArr = selectGoods;
        this.multiShopGoods.forEach((item)=>{
          if(item.venderId==this.curretnVenderId) {
            item.skuIds = skuIds;
          }
        })
        this.orderLotteryActivityPartakeRule.lotteryCondition.sellerSkuList.forEach((item)=>{
          if(item.venderId==this.curretnVenderId) {
            item.skuIds = skuIds;
            item.itemList = selectGoods
          }
        })
      }
      this.selectGoodsState = false;
    },
    // 是否自营
    publicOpen() {
      publicOpen().then((res) => {
        if (res.message) {
          var data1 = new Date(res.message);
          var data2 = new Date();
          this.jdCrm.endTime = res.message;
          if (data1.getTime() > data2.getTime()) {
            this.jdCrm.isCrm = true;
          } else {
            this.jdCrm.isCrm = false;
          }
        }
      });
    },
    toCreated(uitype, templateId = 0) {
      if (sessionStorage.getItem("venderType") == 0) {
        this.localStepNum = 1;
      } else {
        if (this.jdCrm.isCrm) {
          this.localStepNum = 1;
        } else {
          this.$message({
            type: "warning",
            message: "自营店铺需要搭配云短信CRM使用!请联系客服!",
          });
        }
      }
      if (templateId) {
        this.templateId = templateId;
      }
      this.templateJson.templateUItype = uitype;
    },
    toCreated1(uitype, templateId = 0) {
      this.localStepNum = 1;
      this.templateJson.templateUItype = uitype;
      if (templateId) {
        this.templateId = templateId;
      }
    },
    toCRM() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_blank"
      );
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.ruleForm.exposureSwitch = false;
      this.selectGoodsStateFilter = false;
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox){
  margin: 16px 0;
}

.prosi {
  position: absolute;
  bottom: 114px;
  right: -40px;
}
.rule_box {
  width: 900px;
  // height: 217px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.active-width {
  width: 1300px;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  // margin: 11px 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 0px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #fe4d45;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #fe4d45;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #fe4d45;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2768ff;
      cursor: pointer;
    }
    .rule-tip {
      margin-top: 8px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #fe4d45;
        border-bottom: 1px solid #fe4d45;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #fe4d45;
        border-left: 1px solid #fe4d45;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      // font-family: system-ui;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;
      &:hover {
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset {
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
  .support {
    display: flex;
    align-items: center;
    &-text {
      margin: 0px 8px;
    }
    &-icon {
      color: #ccc;
      cursor: pointer;
    }
  }
}
.grey-color {
  color: #ccc;
}
.shoptitle-label {
  margin-right: 12px;
  min-width: 60px;
  text-align: right;
  font-size: 12px !important;
}
.mb8 {
  margin-bottom: 8px;
}
</style>
<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  //   .el-step__line {
  //     background-color: #fe4d45;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  // }
  // .el-step__title.is-process {
  //   color: #fe4d45;
  // }
  // .el-step__title.is-success {
  //   color: #fe4d45;
  // }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.flex-shop {
  display: flex;
  flex-wrap: wrap;
}
</style>
